import {
    Component,
    OnInit,
    Input,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    AfterViewChecked,
    AfterViewInit,
    ViewChild,
    ElementRef,
    OnDestroy,
    Inject,
    PLATFORM_ID
} from '@angular/core';

import { Observable } from 'rxjs';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Subscription } from 'rxjs/Subscription';
import 'rxjs/add/observable/fromEvent';
import { DEVICE_INFO, APP_SETTINGS, DeviceInfo, CarouselRowConfig } from 'angular-engine/modules/ng-express-engine/tokens';
@Component({
    selector: 'carousel-row',
    templateUrl: 'carousel-row.template.html',
    styleUrls: ['carousel-row.style.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class CarouselRow {
    @Input() item: any;
    @Input() items: Array<any>;
    @Input() config: CarouselRowConfig;
    @Input() isOnScreen: boolean;
    @ViewChild('swiperNext') swiperNext;
    @ViewChild('swiperPrev') swiperPrev;
    @ViewChild('scrollbar') swiperScrollbar;

    private isServer: boolean;
    private scrollPos: Subscription;
    protected swiperConfig: any;
    private ready: boolean;
    private loaded: boolean = false;
    private selIndex: number;
    settings: any = {
        dim: true,
        grow: true,
        showBack: true,
        showDetail: true,
        showCopy: false,
        viewSlides: 3,
        spacing: 20,
        loopAdditionalSlides: 5,
        cellStyle: 'media'
    };

    private get layout(): string {
        return this.config.style ? this.config.style : this.config.wide ? "container-fluid" : "container";
    }

    constructor(
        @Inject(PLATFORM_ID) platformId: string,
        @Inject(DEVICE_INFO) private deviceInfo: DeviceInfo,
        @Inject(APP_SETTINGS) private appSettings: Object,
        private cd: ChangeDetectorRef,
        private el: ElementRef) {
        this.isServer = isPlatformServer(platformId);
    }

    private isMobile(): boolean {
        return this.deviceInfo.isMobile;
    }
    ngOnDestroy() {
        // if(this.scrollPos){
        //     this.scrollPos.unsubscribe();
        // }
        this.swiperConfig = null
    }
    ngOnChanges() {
        //console.log("Change detected");
    }

    ngOnInit() {
        //apply default config
        Object.assign(this.settings, this.config);
        this.config.activeSlug = this.item && this.item.internal_state && this.item.internal_state.active_route_slug;

        //todo: retrieve 'slide position' from state 
        this.selIndex = 0;
        if (this.config.activeSlug) {
            let index = this.items.findIndex(s => (s.meta || s).slug === this.config.activeSlug);
            if (index > -1) this.selIndex = index;
        }
    }

    ngAfterViewInit() {

        if (this.items.length > 0) {
            this.swiperConfig = {
                //pagination: '.swiper-pagination',
                //paginationClickable: true,
                initialSlide: this.selIndex,
                spaceBetween: this.config.spacing || 20,
                slidesPerView: this.config.viewSlides || 3,
                centeredSlides: this.config.center,
                loop: this.config.loop,
                loopAdditionalSlides: this.config.loopAdditionalSlides || 5,
                onInit: (inst) => {
                    if (!this.loaded) {
                        this.loaded = true;
                    }

                    if (!this.isServer) {
                        window.dispatchEvent(new Event('resize'));
                    }

                    this.fireScroll()
                },
                onSlideChangeStart: (inst) => {
                    if (this.isMobile() && !this.isServer) {

                    }
                },
                onSlideChangeEnd: (inst) => {
                    this.isOnScreen = true;

                    this.fireScroll()
                },
                breakpoints: {
                    1024: {
                        slidesPerView: 2,
                        // spaceBetween: 40
                    },
                    768: {
                        slidesPerView: "auto",
                        spaceBetween: 10
                    },
                    // 640: {
                    //     slidesPerView: 2,
                    //     spaceBetween: 20
                    // },
                    // 320: {
                    //     slidesPerView: 1,
                    //     spaceBetween: 10
                    // }
                }
            };

            if (!this.isMobile()) {
                this.swiperConfig.nextButton = this.swiperNext && this.swiperNext.nativeElement;
                this.swiperConfig.prevButton = this.swiperPrev && this.swiperPrev.nativeElement;
            }

            this.ready = true;
            this.loaded = true;
            this.cd.detectChanges();
        }
    }

    private fireScroll() {
        //forces lazy-load items to load when traversing the carousel
        window.dispatchEvent(new Event("scroll"));
    }

    isActive(slide) {
        return this.config.activeSlug && slide && slide.slug === this.config.activeSlug;
    }

    getCellConfig(cell) {
        var cellConfig = {
            size: 'md',
            imageType: this.settings.imageType,
            noLazy: true
        }
        Object.assign(cellConfig, this.settings)
        return cellConfig;
    }
}



// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/carousel-row/carousel-row.component.ts